export default __webpack_public_path__ + "static/media/anjila.e59279a6.png";